export default __webpack_public_path__ + "static/media/travelfleek_skip_login.faf6379a.mp4";